module.exports = __webpack_public_path__ + "img/lpc.81b441e4.jpg";